const ITEMS = [
  "Ogni foto è una stella",
  "La nostra carrellata",
  "Momenti che restano",
  "Sempre noi due",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="marquee" aria-hidden="true" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div className="marquee-half" key={half}>
            {row.map((item, i) => (
              <span className="marquee-item" key={`${half}-${i}`}>
                {item} <span className="marquee-star">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
